import { render, staticRenderFns } from "./ShifttypeCrud.vue?vue&type=template&id=4e731a16"
import script from "./ShifttypeCrud.vue?vue&type=script&lang=js"
export * from "./ShifttypeCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports